import { render, staticRenderFns } from "./rc-crm-note-card.vue?vue&type=template&id=3c479db0&scoped=true&"
import script from "./rc-crm-note-card.vue?vue&type=script&lang=js&"
export * from "./rc-crm-note-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c479db0",
  null
  
)

export default component.exports